import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import Announcement from "../model/Announcement";

export const AnnouncementDetailsApiService = async (
  request: number
): Promise<Announcement> => {
  const url = `/announcements/${request}/`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAnnouncementDetailsApiService = (
  id: number,
  enabled = true
) =>
  useQuery<Promise<Announcement>, AxiosError, Announcement>(
    ["AnnouncementDetailsApiService", id],
    () => AnnouncementDetailsApiService(id),
    {
      enabled,
    }
  );

export default useAnnouncementDetailsApiService;
